import { StoreState } from '../reducers/store.types';
import { JobsState } from './jobs.reducer';

export const getJobsState = (state: StoreState): JobsState => state.jobs;
